import styled, { css } from 'styled-components/macro'

import { transparentize } from 'polished'

export const Value = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.4rem;
  line-height: 1.33;
  text-align: left;
  color: ${(props) => props.theme.color.text};
`

export const Wrapper = styled.div<{ area?: string; justifySelf?: string }>`
  display: inline-flex;
  flex-direction: column;
  align-self: center;
  gap: 0.4rem;
  grid-area: ${(props) => props.area};
  justify-self: ${(props) => props.justifySelf};
  ${(props) =>
    props.area === 'Email' &&
    css`
      ${Value} {
        text-align: left;
        text-wrap: balance;
        word-break: break-all;
      }
    `}
`

export const Title = styled.span`
  margin: 0;
  display: inline-block;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.4rem;
  line-height: 1.33;
  text-align: left;
  color: ${(props) => transparentize(0.5, props.theme.color.text)};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    display: none;
  `};
`

export const StyledLink = styled.a`
  color: ${(props) => props.theme.color.primary};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export const DownloadButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${(props) => props.theme.color.primary};
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
